import {
  TenantDto,
  TenantPlanDto,
  TenantRequestDto,
  UpdateTenantRequestDto,
} from '@careapp-group/ng-sdk';
import { BaseFilterType, CaEntityActionsFactory } from '../entity-state/entity-actions-factory';
import { createAction, props } from '@ngrx/store';

class TenantsActions extends CaEntityActionsFactory<
  TenantDto,
  TenantRequestDto,
  UpdateTenantRequestDto,
  BaseFilterType
> {
  constructor(modelName: string) {
    super(modelName);
  }

  requestSaveTenantPlan = createAction(
    `[${this.type}][Request] save tenant plan`,
    props<{
      tenantId: string;
      plan: TenantPlanDto;
    }>(),
  );

  successSaveTenantPlan = createAction(
    `[${this.type}][Success] save tenant plan`,
    props<{
      tenantId: string;
      plan: TenantPlanDto;
    }>(),
  );

  failSaveTenantPlan = createAction(
    `[${this.type}][Fail] save tenant plan`,
    props<{
      tenantId: string;
      error?: any;
    }>(),
  );
}

export const Tenants = new TenantsActions(`Tenants`);
